import { render, staticRenderFns } from "./downloadDialog.vue?vue&type=template&id=15061dc5&scoped=true"
import script from "./downloadDialog.vue?vue&type=script&lang=js"
export * from "./downloadDialog.vue?vue&type=script&lang=js"
import style0 from "./downloadDialog.vue?vue&type=style&index=0&id=15061dc5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15061dc5",
  null
  
)

export default component.exports